import type { ComponentProps } from "react";
import { Link } from "@tanstack/react-router";

import { PROGRESS_BACK_TO_CAREPLAN_LABEL } from "@/domains/progress/utils/progress-page-copy";
import { Button, icons } from "@/ui";

export type ProgressBackToCareplanButtonProps = Omit<ComponentProps<typeof Button>, "asChild">;

/** A link to `/careplan`, never `history.back()`: the label promises where it goes. */
export const ProgressBackToCareplanButton = ({
  size = "lg",
  variant = "secondary-dark",
  ...props
}: ProgressBackToCareplanButtonProps) => {
  return (
    <Button size={size} variant={variant} {...props} asChild>
      <Link to="/careplan">
        <icons.ArrowLeftIcon className="size-5" />

        {PROGRESS_BACK_TO_CAREPLAN_LABEL}
      </Link>
    </Button>
  );
};
